export default "__VITE_ASSET__efe1244e__"